export const WORLD_MECHANICS_VERSION = 3;
export const WORLD_MECHANICS_V3 = Object.freeze({
  version: WORLD_MECHANICS_VERSION,
  worldOrder: Object.freeze(['aries','taurus','gemini','cancer','leo','virgo','libra','scorpio','sagittarius','capricorn','aquarius','pisces']),
  worldElements: Object.freeze(['fire','earth','air','water','fire','earth','air','water','fire','earth','air','water']),
  familyByElement: Object.freeze({ fire: 'volcanic', earth: 'stone', air: 'air_shift', water: 'water_layer' }),
});

export function mechanicForLevel(element, indexInWorld, worldIndex = 0) {
  const stage = indexInWorld <= 5 ? 'intro' : (indexInWorld <= 12 ? 'standard' : (indexInWorld <= 17 ? 'pressure' : 'peak'));
  const base = stage === 'intro' ? 1 : stage === 'standard' ? 2 : stage === 'pressure' ? 3 : 4;
  const family = WORLD_MECHANICS_V3.familyByElement[element] || 'none';
  return Object.freeze({ family, stage, density: family === 'none' ? 0 : Math.min(4, base + (worldIndex % 3 === 2 ? 1 : 0)) });
}
